import { render, staticRenderFns } from "./Clean_eating.vue?vue&type=template&id=3ed5c4c2&"
import script from "./Clean_eating.vue?vue&type=script&lang=js&"
export * from "./Clean_eating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports